module.exports = __webpack_public_path__ + "static/2-2b1d9af09056b5582338e0ba784d60ad.jpg";